import DownloadFilePopupFormComponent from '../../form/js/download-file-popup-form.component';

export default class DownloadCatalogueComponent extends DownloadFilePopupFormComponent {
}



// WEBPACK FOOTER //
// ./app/components/download-catalogue/js/download-catalogue.component.js